import { fetchMyApplications, setDeals, setLoading, setError, setFetchedAt } from './routines'
import { getMyApplications } from '@/api/applications'
import { companyGetters } from '@/store/modules/company/routines'
import { authGetters } from '@/store/modules/auth/routines'

export default {
  async [fetchMyApplications.TRIGGER]({ commit, rootGetters }) {
    const companyId = rootGetters[companyGetters.COMPANY_ID]
    const groupId = rootGetters[authGetters.GROUP_ID]

    if (!companyId || !groupId) return

    commit(setLoading.TRIGGER, true)
    commit(setError.TRIGGER, false)
    try {
      const { data } = await getMyApplications(companyId, groupId)
      const deals = data?.opportunities || []
      commit(setDeals.TRIGGER, deals)
      commit(setFetchedAt.TRIGGER, Date.now())
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('FETCH_MY_APPLICATIONS failed:', e)
      commit(setDeals.TRIGGER, [])
      commit(setError.TRIGGER, true)
    } finally {
      commit(setLoading.TRIGGER, false)
    }
  }
}
